import { Button, Card, Popover } from "antd";
import React, { useEffect, useState } from "react";
import {
  EditOutlined,
  DeleteFilled,
  UserOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function PackageBox(props) {
  const Navigate = useNavigate();
  const [balck_theme, set_balck_theme] = useState(true);

  useEffect(() => {
    const local_theme = localStorage.getItem("dark_theme");
    if (local_theme === "dark") {
      set_balck_theme(true);
    } else {
      set_balck_theme(false);
    }
  }, []);

  return (
    <div>
      <Card
        //style={{ width: 300 }}
        style={{ width: "100%", borderRadius: 8, boxShadow: balck_theme ? "0 4px 8px rgba(59, 58, 58, 0.45)" : "0 4px 8px rgba(0, 0, 0, 0.1)" }}
        cover={
          <img
            alt="example"
            src={props.package_image}
            //style={{ height: 250 }}
            style={{
              display: "block",
              width: "100%",
              borderRadius: "8px 8px 0 0",
              minHeight: "26vh"
            }}
          />
        }
        actions={[
          // <Popover content={"Edit Package details"}>
          //   <Button
          //     type="primary"
          //     size="small"
          //     onClick={() => Navigate("/edit-package/" + props.id)}
          //     disabled
          //   >
          //     <EditOutlined />
          //   </Button>
          // </Popover>,

          <Popover content={"View Package learners"}>
            <Button type="primary" size="small" onClick={() => Navigate(`/package-learners/${props.id}`, {
              state: { from: "/packages" },
            })}>
              {/* <UserOutlined /> */}
              Learners
            </Button>
          </Popover>,

          <Popover content={"View Package Courses"}
            onClick={() => Navigate("/package-courses/" + props.id)}>
            <Button color="green" variant="solid" size="small">
              {/* <SnippetsOutlined /> */}
              Courses
            </Button>
          </Popover>,

          // <Popover content={"Delete course"}>
          //   <Button color="red" variant="solid" size="small">
          //     <DeleteFilled />
          //   </Button>
          // </Popover>,
        ]}
      >
        <Card.Meta style={{ height: "80px" }} title={props.package_name} description={props.package_tag_line} />
      </Card>
    </div>
  );
}
